import { Fragment, useState } from "react";

import useStyles from "./styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import { Drawer } from "../Drawer";
import { useTheme, useMediaQuery } from "@material-ui/core";
import { Header } from "../Header";
import { useAuth } from "oidc-react";
import { useLocation, useRouteMatch } from "react-router-dom";

const Layout = ({ children, ...props }: any) => {
    var classes = useStyles();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), {
        noSsr: true,
    });

    const auth = useAuth();

    let location = useLocation();
    let match = useRouteMatch("/login/external/:provider");
    var hidden = match?.isExact;

    const [drawerOpen, setDrawerOpen] = useState(false);

    return (
        <Fragment>
            {auth.userData &&
                (location.pathname.startsWith("/user/") ||
                    location.pathname.startsWith("/forbidden")) && (
                    <Fragment>
                        <Header
                            onMenu={() => setDrawerOpen(!drawerOpen)}
                            showMenu={isMobile}
                        />
                        <Drawer isOpen={!(isMobile && !drawerOpen)} />
                    </Fragment>
                )}
            {!auth.isLoading ? (
                <Fragment>
                    <div className={classes.toolbar} />
                    <Grid container component="main" className={classes.root}>
                        <CssBaseline />
                        {!hidden ? (
                            <Fragment>
                                <Grid
                                    item
                                    xs={12}
                                    sm={8}
                                    md={5}
                                    component={Paper}
                                    elevation={6}
                                    square
                                >
                                    <div className={classes.paper}>
                                        {children}
                                    </div>
                                    <Box mt={5}>
                                        <Copyright />
                                    </Box>
                                </Grid>
                            </Fragment>
                        ) : (
                            <>
                                <div className={classes.plane}>{children}</div>
                            </>
                        )}
                    </Grid>
                </Fragment>
            ) : (
                <div>{children}</div>
            )}
        </Fragment>
    );
};

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {"Copyright © "}
            <Link color="inherit" href="https://www.ecomsur.com/">
                Ecomsur S.A.
            </Link>{" "}
            {new Date().getFullYear()}
            {"."}
        </Typography>
    );
}

export default Layout;
